module.exports = __webpack_public_path__ + "static/media/pause.53ce4f8b.svg";